var _path, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8 2.79999C9.05739 2.79999 8.3452 3.09499 7.8201 3.62009C7.295 4.14519 7 4.85738 7 5.59999V22.4C7 23.1426 7.295 23.8548 7.8201 24.3799C8.3452 24.905 9.05739 25.2 9.8 25.2H18.2C18.9426 25.2 19.6548 24.905 20.1799 24.3799C20.705 23.8548 21 23.1426 21 22.4V5.59999C21 4.85738 20.705 4.14519 20.1799 3.62009C19.6548 3.09499 18.9426 2.79999 18.2 2.79999H9.8ZM14 22.4C14.3713 22.4 14.7274 22.2525 14.9899 21.9899C15.2525 21.7274 15.4 21.3713 15.4 21C15.4 20.6287 15.2525 20.2726 14.9899 20.01C14.7274 19.7475 14.3713 19.6 14 19.6C13.6287 19.6 13.2726 19.7475 13.0101 20.01C12.7475 20.2726 12.6 20.6287 12.6 21C12.6 21.3713 12.7475 21.7274 13.0101 21.9899C13.2726 22.2525 13.6287 22.4 14 22.4Z",
    fill: "#6D57DF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.6389,
    y1: 5.47223,
    x2: 16.3611,
    y2: 5.47223,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6b1e618422a4d7b8af42cac3505ab417.svg";
export { ForwardRef as ReactComponent };